//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

export const WideInput = (
  props: React.InputHTMLAttributes<HTMLInputElement>,
) => {
  const appliedProps = {
    ...props,
    className: (props.className || '') + ' cu-form-control',
  };
  return <FullLengthInput {...appliedProps} />;
};

const FullLengthInput = styled.input`
  width: 100%;
`;
